import { createSelector } from '@ngrx/store';

import * as fromApp from '../reducers/app.reducers';
import * as fromRoot from '../reducers';


export const selectAppError = createSelector(fromRoot.selectAppState, fromApp.getError);
export const selectPageTitle = createSelector(fromRoot.selectAppState, fromApp.getPageTitle);



// WEBPACK FOOTER //
// ./src/app/core/store/selectors/app.selectors.ts